module.exports = __webpack_public_path__ + "static/media/inf_78og79.0ec2236a.mp3";